import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Url } from "../../config/config";
import Modal from "react-bootstrap/Modal";
import Multiselect from "multiselect-react-dropdown";
import { Pdf, Jpg, Png, Jpeg } from "../../assets/icons";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import DrawPolygon from "../DrawPolygon";
import { Instance } from "../../config/Instance";
import { dateFormat } from "../../utils";
import Pagination from "react-js-pagination";

export default function UserDetails() {
  // useParam react-router-hook for getting id form marketing-partner-list
  const { id } = useParams();
  const navigate = useNavigate();

  //******************* All State for Marketing Partner Details ***********************//
  // state for storing data of marketing partner details
  const [details, setDetails] = useState({});

  // state for storing Leads of marketing partner for details
  const [leads, setLeads] = useState([]);

  // state for store total count of row in table
  const [total, setTotal] = useState(0);

  // state for store active page no in list
  const [activePage, setActivePage] = useState(1);

  //******************** Custom Hook for Loader **************************//
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // variable for Sr.No of Leads table Record
  var count = (activePage - 1) * 10 + 1;

  //************ Start All Function for Marketing partner Details ******************//

  //*************** Marketing partner details************** */
  const getDetails = async (page = 1) => {
    try {
      showLoader();
      const { data } = await Instance.get(
        `/marketing/details?marketingId=${id}&page=${page}`
      );
      if (data.status === 200) {
        setDetails(data.data.user);
        setLeads(data.data.allLead);
        setTotal(data.data.total);
        hideLoader();
      } else {
        toast.error(data.message);
        hideLoader();
      }
    } catch (err) {
      console.log(err);
    }
  };

  //**********************Handel Pagination OnChange ******************/
  const handlePageChange = (event) => {
    setActivePage(event);
    getDetails(event);
  };

  //********************** View According to documents ******************/
  const viewHandler = (_id, id, status) => {
    navigate(`/marketing-partner/details/leads-details/${_id}/${id}`, {
      state: { stepStatus: status },
    });
  };

  // useEffect it run only once at the time of marketing partner details's API calling
  useEffect(() => {
    getDetails();
  }, []);

  return (
    <React.Fragment>
      <title>Marketing Partner Details</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          {loader}
          <div className="Small-Wrapper">
            <h4 className="Title back_wrap">
              {" "}
              <Link to="/marketing-partner" className="back_btn">
                <i className="fa fa-arrow-left"></i>
              </Link>
              Marketing Partner Details
            </h4>

            <div className="OrderArea">
              <ul>
                <li>
                  <span>Full Name</span>
                  <p className="detail-value">{details?.name ? details.name : "- - -"}</p>
                </li>
                <li>
                  <span>Company Name</span>
                  <p className="detail-value">{details?.companyName ? details.companyName : "- - -"}</p>
                </li>
                <li>
                  <span>Mobile Number</span>
                  <p className="detail-value">{details?.mobile ? details.mobile : "- - -"}</p>
                </li>
                <li>
                  <span>Email Address</span>
                  <p className="detail-value">{details?.email ? details.email : "- - -"}</p>
                </li>
                <li>
                  <span>State</span>
                  <p className="detail-value">{details?.state ? details.state : "- - -"}</p>
                </li>
                <li>
                  <span>City</span>
                  <p className="detail-value">{details?.city ? details.city : "- - -"}</p>
                </li>
                <li>
                  <span>Created Date</span>
                  <p className="detail-value">{details?.createdAt ? dateFormat(details.createdAt) : "- - -"}</p>
                </li>
              </ul>
            </div>
          </div>

          {/* Marketing partner Leads area */}
          <div className="Small-Wrapper">
            {leads?.length > 0 ? (
              <>
                <div className="TableList">
                  {loader}
                  <table>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Full Name</th>
                        <th>Company Name</th>
                        <th>Mobile Number</th>
                        <th>Created Date</th>
                        <th>Status</th>
                        <th>Eligibility Status</th>
                        <th>View Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leads &&
                        leads.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>{count++}</td>
                              <td>{`${item.firstName} ${item.lastName}`}</td>
                              <td>{item.nameOfBusiness}</td>
                              <td>{item.contactNum}</td>
                              <td>{dateFormat(item.createdAt)}</td>
                              <td>{item?.isActive ? "Active" : "Inactive"}</td>
                              <td>
                                <center>
                                  {item?.isEligible
                                    ? "Eligible"
                                    : "Not eligible"}
                                </center>
                              </td>
                              <td>
                                &nbsp;&nbsp;
                                {/* <center> */}
                                <button
                                  className="btn button"
                                  onClick={() =>
                                    viewHandler(item._id, id, item.step_status)
                                  }
                                >
                                  View
                                </button>
                                {/* </center> */}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>

                {/* Add pagination */}
                {total > 10 ? (
                  <div className="Pagination">
                    <Pagination
                      activePage={activePage}
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      itemsCountPerPage={10}
                      totalItemsCount={total}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                    />
                  </div>
                ) : null}
                {/* End pagination */}
              </>
            ) : (
              <h4 className="Title">No Leads Found</h4>
            )}
          </div>
          {/* End Marketing partner Leads Area */}
        </div>
      </div>
    </React.Fragment>
  );
}
